import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import NotFound from '../pages/NotFound.vue'
import { firebase } from '../firebase'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('../pages/Home/Home.vue'),
  },
  {
    path: '/services',
    name: 'services',
    component: () => import('../pages/Services/Services.vue'),
    children: [
      {
        path: 'headhunting',
        name: 'headhunting',
        component: () => import('../pages/Services/Headhunting.vue'),
      },
      {
        path: 'reclutamiento-y-seleccion',
        name: 'reclutamiento-y-seleccion',
        component: () => import('../pages/Services/Recruitment.vue'),
      },
      {
        path: 'difusion-de-vacantes',
        name: 'difusion-de-vacantes',
        component: () => import('../pages/Services/Broadcast.vue'),
      },
      {
        path: 'estudios-socioeconomicos',
        name: 'estudios-socioeconomicos',
        component: () => import('../pages/Services/Economics.vue'),
      },
      {
        path: 'evaluaciones-psicometricas',
        name: 'evaluaciones-psicometricas',
        component: () => import('../pages/Services/Psicometrics.vue'),
      },
      {
        path: 'orientacion-vocacional',
        name: 'orientacion-vocacional',
        component: () => import('../pages/Services/Orientation.vue'),
      },
      {
        path: 'consultoria-de-rrhh',
        name: 'consultoria-de-rrhh',
        component: () => import('../pages/Services/Consultancy.vue'),
      },
    ],
  },
  {
    path: '/jobs',
    name: 'jobs',
    component: () => import('../pages/Jobs/Jobs.vue'),
  },
  {
    path: '/jobs/board/apply',
    name: 'jobs-board-apply',
    component: () => import('../pages/Jobs/JobBoardForm.vue'),
  },
  {
    path: '/jobs/:id',
    name: 'job-detail',
    component: () => import('../pages/Jobs/JobDetail.vue'),
    beforeEnter: async (to, _, next) => {
      const { useJobStore } = await import('../stores/jobStore')
      const jobStore = useJobStore()
      const jobData = await jobStore.getJobById(to.params.id as string)
      if (!jobData) {
        next({ name: 'not-found' })
      } else {
        next()
      }
    },
  },
  {
    path: '/jobs/:id/apply',
    name: 'job-apply',
    component: () => import('../pages/Jobs/ApplyForm.vue'),
    beforeEnter: async (to, _, next) => {
      const { useJobStore } = await import('../stores/jobStore')
      const jobStore = useJobStore()
      const jobData = await jobStore.getJobById(to.params.id as string)
      if (!jobData) {
        next({ name: 'not-found' })
      } else {
        next()
      }
    },
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import('../pages/PrivacyPolicy.vue'),
  },
  {
    path: '/backoffice/login',
    name: 'backoffice-login',
    component: () => import('../pages/Backoffice/Login.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/backoffice/dashboard',
    name: 'backoffice-dashboard',
    component: () => import('../pages/Backoffice/Dashboard.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/backoffice/jobs',
    name: 'backoffice-jobs',
    component: () => import('../pages/Backoffice/Jobs.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/backoffice/images',
    name: 'backoffice-images',
    component: () => import('../pages/Backoffice/Images.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/backoffice/applicants',
    name: 'backoffice-applicants',
    component: () => import('../pages/Backoffice/Applicants.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/backoffice/job-board',
    name: 'backoffice-job-board',
    component: () => import('../pages/Backoffice/JobBoard.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/backoffice/audit-log',
    name: 'backoffice-audit-log',
    component: () => import('../pages/Backoffice/AuditLog.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/backoffice/contacts',
    name: 'backoffice-contacts',
    component: () => import('../pages/Backoffice/Contacts.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    redirect: '/404',
  },
  {
    path: '/404',
    name: '404',
    component: NotFound,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(to => {
  const auth = firebase.auth()

  return new Promise(resolve => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      unsubscribe()

      if (to.meta.requiresAuth && !user) {
        resolve('/backoffice/login')
        return
      }

      if (to.path === '/backoffice/login' && user) {
        resolve('/backoffice/dashboard')
        return
      }

      resolve(true)
    })
  })
})

export default router
